const cartHandlerHeaderBtnHandler = () => {
    const cartBtn = document.getElementById('cartBtn');
    const cartBtnCounter = document.getElementById('cartBtnCounter');
    if (cartBtn && cartBtnCounter) {
        cartBtn.addEventListener('click', () => {
            const productsInCart = +cartBtnCounter.innerHTML;
            window.location = '/index.php?route=checkout/cart';
        });
    }
};

export default cartHandlerHeaderBtnHandler;
